import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import variables from "styles/base/_universal.scss";
import FooterButtons from "components/FooterButtons";
import PrimaryButton from "components/PrimaryButton";
import { useTranslation } from "react-i18next";
import LinkButton from "components/LinkButton";

import OutsideClickHandler from "react-outside-click-handler";
import { costomEllipsis } from "Uitls/Util";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import RoundedSearchTextField from "components/RoundedSearchTextField";
import styled from "styled-components";
import MultiSelectList from "./MultiSelectList";
//import { OutsideClickHandler } from "Uitls/Util";

import Ibutton from "img/Ibutton.svg";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import CrossIcon from "img/croseicon.svg";

const MultiSelectDropDownWithInlineSearch = (props) => {
  const [optionsToDisplay, setOptionsToDisplay] = useState(props.options.items);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const [searchText, setSearchText] = useState("");

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    getfilteredOptions(props.options.items, searchText);
  }, [searchText, props.options.items]);

  useEffect(() => {
    if (!open && searchText?.length > 0) {
      setSearchText("");
    }
  }, [open]);

  const useStyles = makeStyles((theme) => ({
    popupIndicator: {
      "& span": {
        "& svg": {
          "& path": {
            d: "path('M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z')",
          },
        },
      },
    },
    truncatedChip: {
      display: "inline-flex",
      alignItems: "center",
      width: "auto",
      height: "20px",
      padding: "2px !important",
      margin: "0 1px 4px 0",
      borderRadius: "10px",
      backgroundColor: "transparent", //variables.paleGrayColor,
      // color: variables.searchTextColor,
      fontSize: "12px",
      fontWeight: variables.fontWeight600,
    },
    selectedChip: {
      backgroundColor: "#FFFFFF",
      margin: "0",
      fontSize: "13px",

      //color: variables.searchTextColor,
    },
    paper: {
      // border: "5px solid black",
      overflowY: "hidden",
      fontSize: variables.fontSmall,

      "& MuiPaper-root": {
        overflowY: "hidden",
      },
    },
    autocomplete: {
      //overflowX: "hidden",

      "& .MuiAutocomplete-inputRoot": {
        height: "42px",
        marginBottom: "16px",
        fontSize: variables.fontSmall,
        paddingLeft: "12px",
        paddingTop: "6px",
      },
      "& .MuiChip-deleteIcon": {
        display: "none",
      },
      "& .MuiFilledInput-root": {
        backgroundColor: `${variables.whiteColor}`,
        height: "42px",
        fontSize: `${variables.fontSmall}`,
        border: `solid 1px ${variables.borderColor}`,
        paddingRight: "0px !important",
        borderRadius: "6px",
        paddingBottom: "0px",
        paddingTop: "4px",
        fontWeight: variables.fontWeight600,
      },
      "& .MuiInputAdornment-root": {
        display: "flex",
        alignItems: "center",
      },
      "& .MuiInputBase-adornedEnd": {
        "& .MuiInputAdornment-positionEnd": {
          display: "flex",
          alignItems: "center",
        },
      },
      "& .MuiAutocomplete-endAdornment": {
        display: "flex",
        alignItems: "center",
        //gap: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        right: "9px !important",
        position: "absolute",
      },
      "&.disabled-autocomplete .MuiAutocomplete-popupIndicator": {
        display: "none !important",
      },
      "&.Mui-disabled .MuiAutocomplete-popupIndicator": {
        display: "none !important",
      },
      "& .MuiFormControl-root": {
        // marginTop: "16px",
      },

      "& .MuiFilledInput-root:hover": {
        backgroundColor: `${variables.whiteColor}`,
      },

      "& .MuiFilledInput-input": {
        //padding: 0;
        lineHeight: "4.5",
        height: "42px",
        transition: "none",
        paddingRight: "5px",
        padding: "0px !important",
        color: variables.searchTextColor,
        //display: "flex",
      },
      "& .MuiInputLabel-formControl": {
        top: "-4px",
      },
      "& .MuiFilledInput-underline :focus": {
        borderBottom: "none",
      },
      "& .MuiFilledInput-underline:before": {
        borderBottom: "none",
      },
      "& .MuiFilledInput-underline:after": {
        borderBottom: "none",
      },
      "& .MuiFilledInput-underline:hover:before": {
        borderBottom: "none",
      },
      "& .MuiSelect-select:focus": {
        borderRadius: "6px",
      },
      "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
        transform: " translate(9px, 15px) scale(0.75)",
      },
      "& .MuiInputBase-root.Mui-disabled": {
        border: "none !important",
      },

      "& .MuiChip-label": {
        paddingLeft: "0px",
        paddingTop: "10px",
        paddingRight: "0px",
        fontWeight: variables.fontWeight600,
        color: `${
          props.options.disabled
            ? variables.disabledTextColor
            : variables.searchTextColor
        } !important`,
      },
      "& .MuiAutocomplete-clearIndicator": {
        //display: "none",
        padding: 0,
        marginRight: "6px",
        marginBottom: "0px",
        marginTop: "0px",
        "& .clear-icon": {
          width: "8px",
          height: "8px",
        },
      },
      "& .MuiAutocomplete-inputFocused": {
        //display: open ? "flex" : "none",
        display: "flex",
      },
      "& .MuiAutocomplete-tag": {
        backgroundColor: "transparent",
      },
      "& .MuiFormLabel-asterisk": {
        color: "#e32b35",
      },
      "& .MuiChip-root .MuiChip-label": {
        color: `${
          props.options.disabled
            ? variables.disabledTextColor
            : variables.searchTextColor
        } !important`,
      },
    },
  }));

  const classes = useStyles();

  const getfilteredOptions = useCallback((data, searchText) => {
    data = data.filter((el) => {
      return el?.displayName?.toLowerCase().includes(searchText?.toLowerCase());
    });

    setOptionsToDisplay(() => {
      return data;
    });

    // return data;
  }, []);

  const updateOpenState = useCallback((isopen) => {
    setOpen(() => {
      return isopen;
    });
  }, []);

  //tooltip
  const getTooltipContent = () => (
    <>
      Select{" "}
      <span style={{ fontWeight: 900 }}>{props.options.parentFieldName}</span>{" "}
      to enable{" "}
      <span style={{ fontWeight: 900 }}>{props.options.currentFieldName}</span>{" "}
      dropdown
    </>
  );
  
  const renderDisabledInfoIcon = () => (
    <StyledTooltip
      title={getTooltipContent()}
      open={showTooltip}
      arrow
      placement="bottom-end"
    >
      <InfoIconWrapper
        onMouseOver={() => setShowTooltip(true)}
        onMouseOut={() => setShowTooltip(false)}
      >
        <img src={Ibutton} alt="info" className="info-icon" />
      </InfoIconWrapper>
    </StyledTooltip>
  );
  const getInputProps = (params) => ({
    ...params.InputProps,
    endAdornment: (
      <>
        {params.InputProps.endAdornment}
        {props.options.disabled &&
          props.options.isDisabledDueToParent &&
          renderDisabledInfoIcon()}
      </>
    ),
  });

  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={() => {
          const element = document.getElementsByClassName(
            "MuiAutocomplete-noOptions"
          );
          if (
            element?.length > 0 &&
            element[0]?.className === "MuiAutocomplete-noOptions"
          ) {
            updateOpenState(false);
          }

          // setSelected(props.options.value || []);
        }}
      >
        <Autocomplete
          key="multi-select-dropdown"
          disabled={props.options.disabled}
          limitTags={1}
          id="search-and-select"
          style={{ width: "100%" }}
          open={open}
          onOpen={() => {
            updateOpenState(true);
          }}
          options={optionsToDisplay}
          value={props.options.value || []}
          className={`${classes.autocomplete} ${classes.paper} ${
            classes.dropdownMenu
          } ${classes.popupIndicator} ${
            props.options.disabled ? "disabled-autocomplete" : ""
          }`}
          getOptionLabel={(option) => option.displayName}
          getOptionSelected={(option, value) => {
            return option.id === value.id;
          }}
          getOptionDisabled={(option) => option.isNotSelectable}
          renderInput={(params) => (
            <TextField
              id="tf-mui-search-select"
              {...params}
              label={props.options.label}
              variant="filled"
              placeholder={
                props.options.value?.length > 0
                  ? ""
                  : t("generalTexts.searchAndSelect")
              }
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              required={props.options.required}
              inputProps={{
                ...params.inputProps,
                autoComplete: "off",
                value: searchText,
                // style: { display: !open ? "none" : "block" },
              }}             
              InputProps={getInputProps(params)}
            />
          )} //
          renderTags={(value, getTagProps) => {
            if (!open && value?.length > 0) {
              const selectedOptions = value?.slice(0, 1);
              const truncatedOptions = value?.slice(1);
              const label = `${
                selectedOptions[0].displayName?.length > 15
                  ? costomEllipsis(selectedOptions[0].displayName, 15)
                  : selectedOptions[0].displayName
              }
            ${truncatedOptions.length ? " +" + truncatedOptions.length : ""}`;

              return [
                ...selectedOptions.map((option, index) => (
                  <>
                    <span
                      style={{
                        color: props.options.disabled
                          ? variables.disabledTextColor
                          : variables.searchTextColor,
                      }}
                    >
                      {selectedOptions[0].displayName?.length > 25
                        ? costomEllipsis(selectedOptions[0].displayName, 25)
                        : selectedOptions[0].displayName}
                    </span>
                    <Chip
                      key={option.displayName}
                      label={
                        truncatedOptions.length
                          ? " +" + truncatedOptions.length
                          : ""
                      }
                      // classes={{ root: classes.selectedChip }}
                      {...getTagProps({ index })}
                    />
                  </>
                )),
              ];
            }

            return null;
          }}
          multiple
          disableCloseOnSelect={true}
          closeIcon={
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                visibility:
                  props.options.value &&
                  props.options.value.length > 0 &&
                  !props.options.disabled
                    ? "visible"
                    : "hidden",
              }}
            >
              <img src={CrossIcon} alt="clear" className="clear-icon" />
            </span>
          }
          onChange={(e, value, reason) => {
            if (reason === "clear") {
              if (props.options.handleChange) {
                props.options.handleChange([]);
              }
            }
          }}
          ListboxComponent={(listboxProps) => (
            <ListboxComponentCustom
              {...listboxProps}
              updateOpenState={updateOpenState}
              alreadySelected={props?.options?.value}
              optionsToDisplay={optionsToDisplay || []}
              open={open}
              metadata={props}
              applySelection={(selectedValues) => {
                return props?.options?.handleChange(selectedValues);
              }}
            />
          )}
        />
      </OutsideClickHandler>
    </div>
  );
};

export default MultiSelectDropDownWithInlineSearch;

const ListboxComponentCustom = ({
  updateOpenState,
  alreadySelected,
  optionsToDisplay,
  open,
  applySelection,
  metadata,
}) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const [selected, setSelected] = useState(alreadySelected || []);

  useEffect(() => {
    setSelected(() => {
      return alreadySelected || [];
    });
  }, [alreadySelected]);

  const shouldApplyBeDisbaled = () => {
    return (
      (!alreadySelected || alreadySelected?.length === 0) &&
      selected?.length === 0
    );
  };

  const primaryButton = (
    <PrimaryButton
      title={t("generalTexts.apply")}
      handleClick={() => {
        applySelection(selected);
        updateOpenState(false);
      }}
      disabled={shouldApplyBeDisbaled()}
    />
  );

  const secondaryButton = (
    <LinkButton
      title={t("generalTexts.clear")}
      handleClick={() => {
        setSelected([]);
        // props.options.handleChange([]);
      }}
      disabled={selected?.length === 0}
    />
  );

  const handleChange = useCallback((isChecked, option) => {
    return setSelected((value) => {
      const index = value?.findIndex((el) => {
        return el.id === option.id;
      });
      if (isChecked) {
        if (index === -1) {
          value = (value || []).concat(option);
        }
      } else if (index > -1) {
        value = value?.filter((item) => item.id !== option.id);
      }
      return value;
    });
  }, []);

  return (
    <OutsideClickHandler
      ref={ref}
      onOutsideClick={() => {
        updateOpenState(false);
        setSelected(alreadySelected || []);
      }}
      key="multi-select-list-drp-dwn"
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={
            metadata?.metadata?.country?.displayName?.trim?.() ===
            "United States"
              ? "united-states-class"
              : "default-class"
          }
        >
          <MultiSelectList
            data={optionsToDisplay}
            open={open}
            enableSearch={false}
            handleSelection={(isChecked, option) => {
              handleChange(isChecked, option);
            }}
            height={
              metadata?.metadata?.country?.displayName?.trim?.() ===
              "United States"
                ? "130px"
                : "200px"
            }
            selected={selected}
          />
        </div>
        <FooterButtons
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
          size="sm"
        />
      </div>
    </OutsideClickHandler>
  );
};

//tooltip styles
const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;

  .info-icon {
    color: ${variables.infoIconColor || "rgba(0, 0, 0, 0.54)"};
    height: 12px;
    transition: color 0.2s ease;
    margin-bottom: 8px; // Remove any margin-bottom to avoid unwanted gap

    &:hover {
      color: ${variables.infoIconHoverColor || "rgba(0, 0, 0, 0.87)"};
    }
  }
`;

const ClearIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
  flex-shrink: 0;

  .clear-icon {
    width: 12px;
    height: 12px;
    display: block;
    transition: opacity 0.2s ease;
  }

  &:hover {
    opacity: 0.8;
  }
`;
const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px 12px",
    borderRadius: "4px",
    maxWidth: "12rem",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "0px",
    marginRight: "18px",
    boxShadow: "0px 0px 8px 0px #231F201F",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "5px",
    borderColor: "#fff",
    transform: "scale(1)",
  },
})(Tooltip);
